import { INSTRUMENTS } from '../constants/Instruments';
import {
  normalizeStyleTag,
  normalizeStyleTagKey,
  normalizeStyleTagList,
} from './styleTags';

export const normalizeInstrumentOptions = (options = INSTRUMENTS) => {
  const seen = new Set();
  const source = Array.isArray(options) ? options : [];

  return source.reduce((normalizedOptions, option) => {
    const label = normalizeStyleTag(typeof option === 'string' ? option : option?.label);
    if (!label) {
      return normalizedOptions;
    }

    const key = normalizeStyleTagKey(label);
    if (seen.has(key)) {
      return normalizedOptions;
    }

    seen.add(key);
    normalizedOptions.push({
      id: typeof option === 'object' && option?.id ? String(option.id) : key,
      label,
      aliases: normalizeStyleTagList(typeof option === 'object' ? option?.aliases : []),
    });
    return normalizedOptions;
  }, []);
};

export const INSTRUMENT_TAG_OPTIONS = Object.freeze(normalizeInstrumentOptions(INSTRUMENTS));
